var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"font-weight-medium px-6",attrs:{"small":_vm.small,"pill":"","color":_vm.isDraft ? undefined : '#73BDC94D',"text-color":_vm.isDraft ? undefined : 'primary'}},[_vm._v(" "+_vm._s(_vm.isDraft ? 'DRAFT' : 'READY')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }